module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e31"
    }
  }, [_vm._v("© 2008 by Sheila Walsh")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e33"
    }
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotation in printed reviews, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e35"
    }
  }, [_vm._v("Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson is a registered trademark of Thomas Nelson, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e37"
    }
  }, [_vm._v("Thomas Nelson, Inc., titles may be purchased in bulk for educational, business, fund-raising, or sales promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e39"
    }
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from The Holy Bible, New International Version"), _c('sup', [_vm._v("®")]), _c('i', [_vm._v(". ")]), _vm._v("Copyright © 1973, 1978, 1984, by International Bible Society. Used by permission of Zondervan Bible Publishing House. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e47"
    }
  }, [_vm._v("Scripture quotations noted NLT are taken from the "), _c('i', [_vm._v("Holy Bible")]), _vm._v(", New Living Translation"), _c('sup', [_vm._v("®")]), _vm._v(", copyright © 1996. Used by permission of Tyndale House Publishers, Inc., Wheaton, IL 60189. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e56"
    }
  }, [_vm._v("Scripture quotations noted NCV are taken from the "), _c('i', [_vm._v("Holy Bible")]), _vm._v(", The New Century Version"), _c('sup', [_vm._v("®")]), _vm._v(". Copyright © 1987, 1988, 1991. Used by permission of Thomas Nelson Publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e65"
    }
  }, [_vm._v("Scripture quotations noted NKJV are taken from The New King James Version. All rights reserved. Copyright © 1982 by Thomas Nelson, Inc. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e67"
    }
  }, [_vm._v("Scripture quotations noted MSG are taken from "), _c('i', [_vm._v("The Message ")]), _vm._v("by Eugene H. Peterson. Copyright © 1993, 1994, 1995, 1996, 2000, 2001, 2002. Used by permission of NavPress Publishing Group. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crtc",
    attrs: {
      "id": "d12e72"
    }
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e75"
    }
  }, [_vm._v("Walsh, Sheila, 1956– "), _c('br'), _vm._v("      Get off your knees and pray / Sheila Walsh. "), _c('br'), _vm._v("         p. cm. "), _c('br'), _vm._v("      Summary: \"A Woman's Guide to Life-Changing Prayer\"—Provided by publisher. "), _c('br'), _vm._v("      Includes bibliographical references. "), _c('br'), _vm._v("      ISBN 978-0-8499-1953-4 (hardcover) "), _c('br'), _vm._v("      ISBN 978-1-4002-8004-9 (IE) "), _c('br'), _vm._v("      1. Prayer—Christianity. 2. Christian women—Religious life. I. Title. "), _c('br'), _vm._v("    BV210.3.W36 2007 "), _c('br'), _vm._v("    248.3'2—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "crtr",
    attrs: {
      "id": "d12e97"
    }
  }, [_vm._v("2007036803")]), _vm._v(" "), _c('p', {
    staticClass: "crtc",
    attrs: {
      "id": "d12e99"
    }
  }, [_c('i', [_vm._v("Printed in the United States of America")]), _c('br'), _vm._v("08 09 10 11 12 13 QW 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb6ed72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wals_ISBN1418537640_epub_c2_r1.vue
// module id = 60
// module chunks = 0